import React from 'react';

import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {CheckCircleIcon} from '@amblique/king-living/app/components/icons';

/**
 * Shop Button
 * @param {Object} props
 * @param {Function} props.onClick
 */
const WhySignUp = (props) => {
  const styles = useMultiStyleConfig('WhySignUp', {});

  return (
    <Box {...styles.container} {...props}>
      <Text {...styles.title}>Why sign up to King Living?</Text>
      <Box {...styles.checkCircleContainer}>
        <Box {...styles.checkCircleItem}>
          <CheckCircleIcon {...styles.checkCircleIcon} />
          <Text {...styles.description}>Lorem ipsum dolor sit amet, consectetur </Text>
        </Box>
        <Box {...styles.checkCircleItem}>
          <CheckCircleIcon {...styles.checkCircleIcon} />
          <Text {...styles.description}>Nulla vitae elit libero, a pharetra augue.</Text>
        </Box>
        <Box {...styles.checkCircleItem}>
          <CheckCircleIcon {...styles.checkCircleIcon} />
          <Text {...styles.description}>Integer posuere erat a ante venenatis dapibus posuere velit aliquet.</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default WhySignUp;
